import styled from 'styled-components'
import {
  COLOR,
  BUTTON_SIZE,
  FONT_SIZE
} from '../../themes'
export const BUTTON = styled.button`
    width: 100%;
    float: left;
    line-height:${BUTTON_SIZE.LINE_HEIGHTS.MD};
    background: ${COLOR.GOLD_1} 0% 0% no-repeat padding-box;
    color: ${COLOR.BLACK_4};
    cursor: pointer;
    text-align: center;
    border-radius: 4px;
    font-size: ${FONT_SIZE.XS};
    outline: none;

    &.is-ui-disabled {
    cursor: not-allowed !important;
    color:${COLOR.GOLD_1} !important;
    border-color:${COLOR.GOLD_1} !important;
    }
    .icon-btn{
      vertical-align: middle;
      margin-bottom: 3px;
      padding-right: 10px
    }
    .round {
      border-radius: 50%;
    }
`
